jQuery(function ($) {

    /**
     * On document load check if one of the filters is currently active. If true, add `(1)` next to filter name.
     */
    $(document).ready(function () {
        if ($('.filter-title').parent().find('.active').length) {
            const activeTitle = $('.filter-title').parent().find('.active').closest('.filters-list').prev();
            const text = activeTitle.text();
            activeTitle.html(`<strong> ${text} (1) <i class="fa fa-angle-up ml-3 lg:ml-2 font-semibold text-black transition rotate-180"></i></strong>`);

            if (window.innerWidth >= 1024) {
                toggleFilters();
            }
        }
    });

    /**
     * On clickaway close all currently open filter dropdowns.
     */
    $(document).on('click', function (e) {
        const filtersList = $('.filters-list');
        const filterTitle = $('.filter-title');

        if (!filtersList.is(e.target) && filtersList.has(e.target).length === 0 &&
            !filterTitle.is(e.target) && filterTitle.has(e.target).length === 0) {

            const openFilterList = $('.filters-list.open');
            if (openFilterList.length > 0) {
                openFilterList.addClass('opacity-0').addClass('invisible').addClass('h-0').removeClass('py-2');
                openFilterList.parent().removeClass('space-y-4');
                openFilterList.prev('.filter-title').children().last().toggleClass('rotate-180');
                openFilterList.removeClass('open');
            }
        }
    });

    /**
     * Switch between mobile and desktop view on resize.
     */
    $(window).on('resize', function (e) {
        if (window.innerWidth >= 1024 && !$('.filters').hasClass('lg:hidden')) {
            $('#search-products').addClass('py-8');
            $('.filters').removeClass('py-8').addClass('py-4');
        } else {
            $('.filters').addClass('py-8').removeClass('py-4');

            if (window.innerWidth >= 1024 && $('.filters').hasClass('lg:hidden')) {
                $('#search-products').removeClass('py-8');
            } else {
                $('#search-products').addClass('py-8');
            }
        }
    });

    /**
     * Display dropdown/show filters list when filter name is clicked.
     */
    $('.filter-title').on('click', function () {
        let filter = $(this);
        let filtersList = filter.next();

        const openFilterList = $('.filters-list.open');
        if (openFilterList.length > 0 && !openFilterList.is(filter.next())) {
            openFilterList.addClass('opacity-0').addClass('invisible').addClass('h-0').removeClass('py-2');
            openFilterList.parent().removeClass('space-y-4');
            openFilterList.prev('.filter-title').children().last().toggleClass('rotate-180');
            openFilterList.removeClass('open');
        }

        filtersList.toggleClass('opacity-0').toggleClass('invisible').toggleClass('h-0').toggleClass('py-2');
        filtersList.parent().toggleClass('space-y-4');
        filter.children().last().toggleClass('rotate-180');
        filter.next().toggleClass('open');
    });

    /**
     * Show/hide filters event.
     */
    $('#filter-button').on('click', function () {
        toggleFilters();
    });

    /**
     * Show/hide filters function.
     */
    function toggleFilters() {
        if (window.innerWidth >= 1024) {
            $('#search-products').toggleClass('py-8');
            $('.filters').toggleClass('py-8').toggleClass('py-4');
        }

        $('.filters').toggleClass('hidden');

        setTimeout(() => {
            $('.filters').toggleClass('opacity-0').toggleClass('invisible').toggleClass('h-0');
        }, 150);

        $('#filter-button').toggleClass('active');
    }

    /**
     * Submit form when filter is selected. If active filter is clicked, remove it and redirect to default view.
     */
    $('.filter').on('click', function () {
        if ($(this).hasClass('active')) {
            let url = window.location.href.split('?');
            window.location.href = url[0];
        } else {
            const selectedFilter = $(this).attr('data-value');

            $('.filters').find('.active').removeClass('active');

            $(this).parent().children().first().val(selectedFilter);
            $('#search-products button[type="submit"]').click();
        }

        $(this).toggleClass('active');
    });

    /**
     * Remove empty input values from query string and redirect with proper one.
     */
    $('#search-products').on('submit', function(e) {
        e.preventDefault();

        const formData = $(this).serializeArray().filter(function(item) {
            return item.value !== '';
        });

        const queryString = $.param(formData);
        window.location.href = `?${queryString}`;
    });
})